import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import ArticleContent from './ArticleContent';

function PostModal({ post, onClose }) {
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [currentContent, setCurrentContent] = useState(null);
  
  const languages = [
    { code: 'en', label: 'English', emoji: '🇺🇸' },
    { code: 'es', label: 'Español', emoji: '🇪🇸' },
    { code: 'ja', label: '日本語', emoji: '🇯🇵' }
  ];

  useEffect(() => {
    setIsLoading(true);
    // Simulate a small delay to ensure content is processed
    const timer = setTimeout(() => {
      setCurrentContent(post[i18n.language]);
      setIsLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, [post, i18n.language]);

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-dark-800 rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 relative">
          <div className="mb-6 flex justify-between items-center">
            <h1 className="text-2xl font-bold text-white">
              {currentContent?.title}
            </h1>
            
            <div className="flex items-center gap-6">
              <select 
                onChange={(e) => i18n.changeLanguage(e.target.value)}
                value={i18n.language}
                className="px-3 py-2 bg-dark-800 text-white border border-dark-700 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {languages.map(({ code, label, emoji }) => (
                  <option key={code} value={code}>
                    {emoji} {label}
                  </option>
                ))}
              </select>

              <button 
                onClick={onClose}
                className="p-1 bg-dark-700 rounded-full hover:bg-dark-600"
              >
                <X className="text-white" size={24} />
              </button>
            </div>
          </div>
          
          {isLoading ? (
            <div className="flex justify-center items-center min-h-[200px]">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
          ) : (
            <ArticleContent content={currentContent?.content} />
          )}
        </div>
      </div>
    </div>
  );
}

export default PostModal;